import { Box, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { Label } from '../../components/atoms/Label';
import { ActivityGrid } from '../../components/molecules/ActivityGrid';
import { BannerCarousel } from '../../components/molecules/Carousel';
import { Promotion } from '../../components/molecules/Promotion';
import { PromotionGrid } from '../../components/molecules/PromotionGrid';
import { Search } from '../../components/molecules/Search';
import { useLocationContext } from '../../contexts/LocationProvider';
import { useTheme } from '../../contexts/ThemeProvider';
import useIsMobile from '../../hooks/use-is-mobile';
import { Footer } from '../../components/organisms/Footer';
import { useProfile } from '@/contexts/ProfileProvider';
import { usePromotions } from '@/service/club/hooks';

interface HomeWithClubProps {
  banners: any[];
  id: string | number | null;
  name: string;
  openModalLogin: () => void;
  customerCentralModule: boolean;
}

export function HomeWithClub({ banners, id, name, openModalLogin }: HomeWithClubProps) {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const isMobile = useIsMobile();
  const { latitude, longitude } = useLocationContext();
  const { ecommerceModule, localModule } = useTheme();
  const onlyLocal = !!localModule && !ecommerceModule;

  const { isFetching, data } = usePromotions(typeof id === 'string' ? parseInt(id) : id, {
    category: 'Cinema',
    latitude,
    longitude,
  });

  return (
    <VStack
      align={'self-start'}
      width="100%"
      marginBottom={{
        base: '100px',
        md: '0px',
      }}
      paddingTop={'10px'}
      spacing={6}
    >
      <BannerCarousel title="Preferidos" banners={banners} />
      {/* {customerCentralModule && <InvoicesSection />} */}

      <VStack align={'self-start'} width={'100%'} spacing={4} padding={'0px 20px'}>
        <Box
          cursor="pointer"
          w="100%"
          sx={{
            '&:hover': {
              textDecoration: 'none',
            },
          }}
          onClick={() => {
            if (!profile) {
              openModalLogin();
              return;
            }
            navigate('/vantagens');
          }}
        >
          <Search disabled />
        </Box>
      </VStack>

      <ActivityGrid />

      {localModule && (
        <PromotionGrid
          showMove={() => {
            if (!profile) {
              openModalLogin();
              return;
            }
            navigate('/vantagens', {
              state: {
                exclusive: true,
                latitude,
                longitude,
              },
            });
          }}
          title={`Exclusivas ${name}`}
          params={{ exclusive: true, latitude, longitude }}
        />
      )}

      {!onlyLocal && (
        <PromotionGrid
          title={`Ecommerce`}
          showMove={() => {
            if (!profile) {
              openModalLogin();
              return;
            }
            navigate('/vantagens', {
              state: {
                mode: 'online',
                featured: true,
              },
            });
          }}
          params={{
            mode: 'online',
            featured: true,
          }}
        />
      )}

      {localModule && (
        <>
          <PromotionGrid
            title="Recentes"
            showMove={() => {
              if (!profile) {
                openModalLogin();
                return;
              }
              navigate('/vantagens', {
                state: {
                  mode: 'local',
                  is_new: true,
                },
              });
            }}
            params={{
              mode: 'local',
              is_new: true,
            }}
          />

          <PromotionGrid
            title="Perto de Você"
            showMove={() => {
              if (!profile) {
                openModalLogin();
                return;
              }
              navigate('/vantagens', {
                state: {
                  mode: 'local',
                  latitude,
                  longitude,
                },
              });
            }}
            params={{ mode: 'local', latitude, longitude }}
          />
        </>
      )}

      {isMobile && !isFetching && data && data?.length > 0 && (
        <VStack align={'self-start'} padding={'0px 20px'} spacing={2} width={`100%`}>
          <Label>Cinemas</Label>
          <Promotion onClick={(url) => navigate(url)} isMobile isFullWidth isCartaz promotion={data[0]} />
        </VStack>
      )}

      {!isMobile && !isFetching && data && data?.length > 0 && (
        <PromotionGrid
          title="Cinemas"
          fullWidth
          showMove={() => {
            if (!profile) {
              openModalLogin();
              return;
            }
            navigate('/vantagens', {
              state: {
                mode: 'online',
                exclusive: true,
              },
            });
          }}
          params={{
            category: 'Cinema',
            latitude,
            longitude,
          }}
        />
      )}

      <Footer />
    </VStack>
  );
}
